import { render, staticRenderFns } from "./PermanentFormTab.vue?vue&type=template&id=d88dce1c&scoped=true"
import script from "./PermanentFormTab.vue?vue&type=script&lang=js"
export * from "./PermanentFormTab.vue?vue&type=script&lang=js"
import style0 from "./PermanentFormTab.vue?vue&type=style&index=0&id=d88dce1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88dce1c",
  null
  
)

export default component.exports